/**
 * Round 10 F1 -- what a finding can be raised against, in one place.
 *
 * A finding's subject is a polymorphic (entity_kind, entity_id) pair
 * whose allowed set is pinned by a DB CHECK and re-stated by
 * `_VALID_ENTITY_KINDS` in backend/twin/findings_admin_router.py. The
 * registers that flag rows -- architecture standards, continuity
 * posture, the supervisory checks -- flag things OUTSIDE that set:
 * facilities, outsourcing contracts, data assets. Offering "raise a
 * finding" on one of those is offering an action the product cannot
 * complete, which is the defect class this programme spent four rounds
 * removing from the ceremonies.
 *
 * `product` is deliberately absent even though the backend admits it:
 * there is no product picker, so the form could not name the subject.
 * This list is what can be raised THROUGH THE FORM, and a backend test
 * asserts it stays a subset of what the API accepts.
 */
export const FINDING_SUBJECT_KINDS = [
  "service",
  "ibs_service",
  "capability",
  "vendor",
  "configuration_item",
] as const;

export type FindingSubjectKind = (typeof FINDING_SUBJECT_KINDS)[number];

export function canRaiseFindingAgainst(kind: string): boolean {
  return (FINDING_SUBJECT_KINDS as readonly string[]).includes(kind);
}

export function raiseFindingPath(kind: string, id: string): string | null {
  return canRaiseFindingAgainst(kind)
    ? `/twin/findings/new?entity_kind=${encodeURIComponent(kind)}&entity_id=${encodeURIComponent(id)}`
    : null;
}
